'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RenderSpot = require('../RenderSpot');

var _RenderSpot2 = _interopRequireDefault(_RenderSpot);

var _RenderSubregion = require('../RenderSubregion');

var _RenderSubregion2 = _interopRequireDefault(_RenderSubregion);

var _RenderGeoname = require('./RenderGeoname');

var _RenderGeoname2 = _interopRequireDefault(_RenderGeoname);

var _RenderCity = require('./RenderCity');

var _RenderCity2 = _interopRequireDefault(_RenderCity);

var _taxonomyNodePropType = require('../PropTypes/taxonomyNodePropType');

var _taxonomyNodePropType2 = _interopRequireDefault(_taxonomyNodePropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenNodes = function flattenNodes(groups) {
  var result = [];
  groups.forEach(function (group) {
    if (group.spots && group.spots.length === 0) return;
    result.push(group.city);
    var spots = [].concat((0, _toConsumableArray3.default)(group.spots.slice(0, group.spots.length - 1)), [(0, _extends3.default)({}, group.spots[group.spots.length - 1], { lastOfGroup: true })]);
    result = result.concat(spots);
  });
  return result.filter(function (node) {
    return node !== null;
  });
};

var ChildList = function ChildList(_ref) {
  var listType = _ref.listType,
      nodes = _ref.nodes,
      onClickNode = _ref.onClickNode,
      loading = _ref.loading,
      error = _ref.error,
      onClickLink = _ref.onClickLink;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-taxonomy-navigator__child-list' },
    function () {
      if (error) {
        return _react2.default.createElement(
          'div',
          null,
          'Sorry, an error occurred'
        );
      } else if (loading) {
        return _react2.default.createElement(
          'div',
          null,
          'Fetching data'
        );
      } else if (listType === 'subregions') {
        return nodes.filter(function (node) {
          return !!node._id && !!node.name;
        }).map(function (node) {
          return _react2.default.createElement(_RenderSubregion2.default, {
            key: node._id,
            subregion: node,
            onClickLink: onClickLink
          });
        });
      } else if (listType === 'geonames') {
        return nodes.map(function (node) {
          return _react2.default.createElement(_RenderGeoname2.default, {
            key: node._id,
            node: node,
            onClickNode: onClickNode,
            onClickLink: onClickLink
          });
        });
      }
      return flattenNodes(nodes).filter(function (node) {
        return !!node.name;
      }).map(function (node) {
        if (node.type === 'geoname') {
          return _react2.default.createElement(_RenderCity2.default, { node: node, key: node._id });
        }
        return _react2.default.createElement(_RenderSpot2.default, { spot: node, key: node._id, onClickLink: onClickLink });
      });
    }()
  );
};

ChildList.propTypes = {
  nodes: _propTypes2.default.arrayOf(_taxonomyNodePropType2.default),
  listType: _propTypes2.default.string,
  onClickNode: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  error: _propTypes2.default.bool,
  onClickLink: _propTypes2.default.func
};

ChildList.defaultProps = {
  onClickLink: null
};

exports.default = ChildList;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TaxonomyNavigator/ChildList.js
// module id = 679
// module chunks = 11